import React from 'react';
import { styled } from 'linaria/react';

const FilesList = styled.ul`
  > li {
    margin: 5px 0;
  }
`;

export const Files = ({ list }) => {
  return (
    <FilesList className="content-area">
      {list.map((file, index) => {
        const data = file.split('#');
        const name = data[0];
        const url = data.length > 1 && data[1];
        return (
          <li key={index}>
            <a target="_blank" rel="noreferrer" href={url}>
              {name}
            </a>
          </li>
        );
      })}
    </FilesList>
  );
};
